import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { defineMessages, injectIntl, intlShape } from 'react-intl';
import Button from '../button/Button';

const messages = defineMessages({
  'first-line': {
    id: 'errorBanner.unableToTake',
    defaultMessage: "We're unable to take online orders right now - ",
  },
});
type Props = {
  intl: intlShape,
  isDesktop: PropTypes.Bool,
};
const EmergencyBanner = ({ intl: { formatMessage }, isDesktop }: Props) => {
  const [bannerClosed, setBannerClosed] = useState(true);
  let storedBanner;
  const closeBanner = () => {
    setBannerClosed(true);
    sessionStorage.setItem('bannerClosed', 'true');
  };

  useEffect(() => {
    if (
      window.location.pathname.includes('/shops/') ||
      window.location.pathname.includes('/service-update/')
    ) {
      setBannerClosed(true);
    } else {
      storedBanner = sessionStorage.getItem('bannerClosed');
      setBannerClosed(!!storedBanner);
    }
  }, []);
  const STYLE_PREFIX = 'c-master-banner';
  return (
    !bannerClosed && (
      <div className={STYLE_PREFIX} id="mastheader-banner">
        <div
          className={`${STYLE_PREFIX}__content ${STYLE_PREFIX}__us-content ${
            !isDesktop && `${STYLE_PREFIX}__content-mobile`
          }`}
        >
          <p>
            {formatMessage(messages['first-line'])}
            <a
              href="/us/service-update/"
              className={`${STYLE_PREFIX}__link`}
              aria-label="Read more about why our online orders are unavailable"
            >
              {'here'}
            </a>
          </p>
        </div>
        <Button
          onClick={closeBanner}
          ariaLabel="close banner"
          modifiers="banner"
          label="X"
        />
      </div>
    )
  );
};

export default injectIntl(EmergencyBanner);
